<template>
    <div class="d-flex align-items-center" :class="alignmentClass">
        <span
            :class="`badge badge-pill badge-${statusClass} text-capitalize`">
            {{ statusName }}
        </span>
        <app-note-editor
            v-if="!!rowData.terminate_date"
            :id="rowData.id"
            :row-data="rowData"
            icon-class="size-26"
            :note-title="$t('termination_reason')"
            :note-description="description"
            :url="`${apiUrl.EMPLOYEES}/${rowData.id}/update-termination-note`"
        />
    </div>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";

export default {
    name: "EmployeeStatus",
    mixins: [FormHelperMixins],
    props: {
        rowData: {},
        alignmentClass: {}
    },
    computed: {
        statusClass() {
            if (this.rowData?.employment_status?.class) {
                return this.rowData.employment_status.class;
            }

            if (this.rowData?.terminate_date) {
                return 'danger';
            }

            return 'secondary';
        },
        statusName() {
            if (this.rowData?.employment_status?.name) {
                return this.rowData.employment_status.name;
            }

            if (this.rowData?.terminate_date) {
                return this.$t('notification_terminated');
            }

            return '-';
        },
        description() {
            if (this.rowData?.termination_reason) {
                return this.rowData.termination_reason;
            }

            if (this.rowData?.employment_status?.pivot?.description) {
                return this.rowData?.employment_status?.pivot?.description;
            }
            return this.$t('default_termination_reason_note');
        }
    }
}
</script>
